module.exports = __webpack_public_path__ + "static/media/rm_06-31.e9ee90c8.png";